/* Client-side PDF export for proposals.
 * Renders a DOM node to a crisp PNG (html-to-image) and lays it into a
 * multi-page A4 jsPDF document. $0 server compute. */
import { toPng } from 'html-to-image';
import { jsPDF } from 'jspdf';

export async function exportNodeToPdf(node, filename = 'proposal.pdf') {
  if (!node) throw new Error('Nothing to export');
  const dataUrl = await toPng(node, {
    pixelRatio: 2,
    backgroundColor: '#ffffff',
    cacheBust: true,
    skipFonts: true,
  });

  const img = new Image();
  await new Promise((res, rej) => { img.onload = res; img.onerror = rej; img.src = dataUrl; });

  const pdf = new jsPDF({ unit: 'pt', format: 'a4' });
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();

  const imgW = pageW;
  const imgH = (img.height / img.width) * imgW;

  if (imgH <= pageH) {
    pdf.addImage(dataUrl, 'PNG', 0, 0, imgW, imgH);
  } else {
    // Slice the tall image across multiple pages.
    let remaining = imgH;
    let offset = 0;
    while (remaining > 0) {
      pdf.addImage(dataUrl, 'PNG', 0, -offset, imgW, imgH);
      remaining -= pageH;
      offset += pageH;
      if (remaining > 0) pdf.addPage();
    }
  }
  pdf.save(filename);
}
